import { keyBy } from "lodash";

import type { VariableMetadata, VariableMetadataMap } from "../types";

export const createVariableMetadataMap = (
  variables: VariableMetadata[],
): VariableMetadataMap => keyBy(variables, "value");
